import { render, staticRenderFns } from "./ProductConfigurationItem.vue?vue&type=template&id=2f10c502&scoped=true"
import script from "./ProductConfigurationItem.vue?vue&type=script&lang=js"
export * from "./ProductConfigurationItem.vue?vue&type=script&lang=js"
import style0 from "./ProductConfigurationItem.vue?vue&type=style&index=0&id=2f10c502&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f10c502",
  null
  
)

export default component.exports